import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

type Props = {
  title?: string;
  rows: [string, string][];
  tinted?: boolean;
};

export default function ShareboxDetailCard({ title, rows, tinted }: Props) {
  const theme = useTheme();
  const accent = theme.palette.primary.main;

  return (
    <Box
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: tinted ? alpha(accent, 0.3) : "grey.300",
        backgroundColor: tinted ? alpha(accent, 0.06) : "background.paper",
        p: 2.5,
      }}
    >
      {title && (
        <Typography sx={{ fontWeight: 700, color: accent, mb: 1.5 }}>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {rows.map(([label, value]) => (
          <Box
            key={label}
            sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ flexShrink: 0 }}
            >
              {label}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 700,
                textAlign: "right",
                minWidth: 0,
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
